import { Navigate } from "react-router-dom";

export default function ProtectedCCH({ children }) {
  const token = localStorage.getItem("cchToken");

  console.log("ProtectedCCH token =", token);
  console.log("URL =", window.location.href);

  if (!token) {
    return <Navigate to="/app/cch/login" replace />;
  }

  return children;
}
